import { createApp, watch, nextTick } from "vue";
import { createPinia } from "pinia";
import { useDebounceFn } from "@vueuse/core";
import { useQuerySync } from "@facet/utils/useQuerySync.js";
import { useFeedStore } from "@facet/utils/store.js";
import App from "./App.vue";

createApp(App).use(createPinia()).mount("#facet");

await nextTick();

const store = useFeedStore();
const { init, sync } = useQuerySync();

init();
await nextTick();
sync();

await Promise.all([
  store.fetchAllFacets(),
  store.fetchItems()
]);

const debouncedFetch = useDebounceFn(() => {
	store.fetchItems();
}, 300);

watch(() => store.filters, debouncedFetch, { deep: true });

watch(() => store.month, async () => {
	await store.fetchItems()
})

watch(() => store.layout, (layout) => {
	localStorage.setItem("facetLayout", layout);
})

window.addEventListener("popstate", init);